import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => {

	return {
		commentAvatar: {
			...theme.other.rooterAvatars.size30,
			...theme.other.rooterAvatars.borderRadius,
			objectFit: "cover"
		},
		commentInput: {
			fontSize : "14px",
			padding  : "0.5rem 0.75rem",
			width    : "100%",
			zIndex   : "1",
			border   : "none"

		},
		commentRootContainer: {
			fontSize          : "1.4rem",
			backgroundColor   : theme.other.colors.input.primary,
			border            : "none",
			minHeight         : "3.5rem",
			paddingLeft       : "1.5rem !important",
			height            : "4.5rem",
			borderRadius      : "100rem",
			"&:focus-visible" : {
				outline: `2px solid ${ theme.other.paletteNew.primaryDarkBlue }`
			}
		},
		textField: {
			padding: "1.8rem 0.4rem"
		},
		icon: {
			width       : "3.5rem",
			height      : "3.5rem",
			display     : "flex",
			alignSelf   : "center",
			marginRight : "-1rem"
		},
		emojiIcon: {
			width        : "4rem",
			height       : "4rem",
			cursor       : "pointer",
			marginRight  : "0.5rem",
			outline      : props?.displayEmoji ? "solid 2px #126bd5" : 0,
			borderRadius : "50%"
		},
		sendIconStyles: {
			cursor  : "pointer",
			opacity : props?.commentInput ? 1 : 0.5

		},
		commentInputContainerDiv: {
			display                 : "flex",
			width                   : "100%",
			backgroundColor         : theme.other.colors.dialog.primary,
			alignItems              : "center",
			borderBottomLeftRadius  : props?.from === "videos" ? "1rem" : "",
			borderBottomRightRadius : props?.from === "videos" ? "1rem" : "",
			padding                 : "0 1rem",

			"& .MuiOutlinedInput-root": {
				"& fieldset": {
					borderRadius : "30px",
					border       : "none",
					background   : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey20 : theme.other.paletteNew.secondaryLightGrey

				},
				"& textarea": {
					color: theme.other.colors.text.primary
				},
				"& textarea::placeholder": {
					fontSize : "1.2rem !important",
					color    : theme.other.colors.text.primary

				}
			},

			"& .MuiOutlinedInput-root.Mui-focused": {

				"& .MuiOutlinedInput-notchedOutline": {
					background: theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey20 : theme.other.paletteNew.secondaryLightGrey
				},

				"& fieldset": {
					border: `2px solid ${ theme.other.paletteNew.primaryDarkBlue } !important`
				}

			},

			[rooterMediaQuery.mobile]: {
				borderRadius: "unset"
			}

		},
		commentInputContainer: {
			// background: theme.other.colors.dialog.secondary
		},
		padding10: {
			padding: "1rem"
		}
	};
} );

